import { useState, useEffect } from 'react';

export default function Hero() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToReserva = () => {
    const element = document.getElementById('reserva');
    element?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="relative h-screen w-full overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://static.readdy.ai/image/05c1898920965e6ade95f2de28aceb5e/3090039c833ebf71f12654f6ab9548b3.jpeg"
          alt="Empreendimento Em Breve - Linhares"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60"></div>
      </div>

      {/* Navigation */}
      <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-white shadow-lg' : 'bg-transparent'}`}>
        <div className="w-full px-6 lg:px-12 py-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center">
              <img 
                src="https://public.readdy.ai/ai/img_res/7ceb0fe6-5632-411f-bdc4-bc51c645f0fc.png" 
                alt="Logo Em Breve"
                className="h-12 w-auto"
              />
            </div>
            <button 
              onClick={scrollToReserva}
              className={`px-8 py-3 rounded-lg font-medium text-sm tracking-wide transition-all duration-300 whitespace-nowrap cursor-pointer ${
                scrolled 
                  ? 'bg-amber-600 text-white hover:bg-amber-700' 
                  : 'bg-white text-gray-900 hover:bg-gray-100'
              }`}
            >
              RESERVE SUA UNIDADE
            </button>
          </div>
        </div>
      </nav>

      {/* Hero Content */}
      <div className="relative z-10 h-full flex items-center justify-center">
        <div className="w-full text-center px-6">
          <p className="text-white text-sm tracking-[0.3em] uppercase mb-6 font-light" style={{ fontFamily: 'Inter, sans-serif' }}>
            Único. Autêntico. Incomparável.
          </p>
          <h1 className="text-white text-7xl lg:text-8xl font-normal mb-8 tracking-wider" style={{ fontFamily: 'DM Serif Display, serif' }}>
            SKYLINE TOWER
          </h1>
          <div className="flex items-center justify-center gap-4 mb-12">
            <div className="h-px w-16 bg-white/50"></div>
            <p className="text-white text-base tracking-wide font-light" style={{ fontFamily: 'Inter, sans-serif' }}>
              TRÊS BARRAS, LINHARES | ES
            </p>
            <div className="h-px w-16 bg-white/50"></div>
          </div>
          <button 
            onClick={scrollToReserva}
            className="bg-amber-600 text-white px-10 py-4 rounded-lg text-sm tracking-wide font-medium hover:bg-amber-700 transition-all duration-300 whitespace-nowrap cursor-pointer"
            style={{ fontFamily: 'Inter, sans-serif' }}
          >
            DESCUBRA O EXCLUSIVO
          </button>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-10">
        <div className="flex flex-col items-center gap-2 animate-bounce">
          <span className="text-white text-xs tracking-widest" style={{ fontFamily: 'Inter, sans-serif' }}>ROLE</span>
          <i className="ri-arrow-down-line text-white text-xl"></i>
        </div>
      </div>
    </section>
  );
}
